import React, { Fragment, useEffect, useRef, useState } from "react";
import Cookies from "js-cookie";
import "react-datepicker/dist/react-datepicker.css";
import { Dialog, Transition } from "@headlessui/react";
import { IoClose, IoRefreshSharp } from "react-icons/io5";
import "react-calendar/dist/Calendar.css";
import { CiCirclePlus } from "react-icons/ci";
import { FaBroom, FaList, FaBug } from "react-icons/fa6";
import { ChevronRight, Stack } from "react-bootstrap-icons";
import * as Icon from "react-bootstrap-icons";
import {Tooltip} from 'react-tooltip';
import MarkdownIt from 'markdown-it';
import { fetchChatHistoryListing, fetchMainChatListing, addMessageQuery, setListingData, fetchNewSuggestion, fetchCannedListing } from "../../redux/actions/queryZoiAction";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import PdfImage from "../../assets/pdf.png";
import PDFThumbnail from "../../assets/Pdfpreview.png";
import "../InternalAma/ama.css";
import "../InternalAma/markdown.css";
import copyIco from "../../assets/copyIco.svg";
import shareIco from "../../assets/sendIco.svg";
import { useNavigate, useParams } from "react-router-dom";
import Toast from "../assetLibComponents/shared/Toast";
import docImg from "../../assets/pdf-img.png";
import zoiReading from "../../assets/zoiReadingEmote.gif";
import guidance from "../../assets/Guidance.png";
import { IoMdDownload } from "react-icons/io";
import { FETCH_CANNED_DOCS } from "../../constants/QueryZoiActionTypes";
import { MdSupportAgent } from "react-icons/md";
import { LuCalendarDays } from "react-icons/lu";
import Calendar from "react-calendar";
import axios from "axios";
import { speechToTextUrl, wsSpeech, wsChatStream, wsAudioBase64 } from "../../utils/env";
import { initAudioContext, playAudioChunk as playAudioChunkUtil, cleanupAudioContext } from "../../utils/audioUtils";
import { getCustomerBranding } from "../../api/customerSiaApi";

// Import Swiper React components
import { Swiper, SwiperSlide } from 'swiper/react';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/effect-coverflow';
import 'swiper/css/pagination';
import 'swiper/css/navigation';

// import required modules
import { EffectCoverflow, Pagination,Navigation } from 'swiper/modules';

// Initialize markdown-it
const md = new MarkdownIt({
  html: true,
  linkify: true,
  typographer: true,
  breaks: true,
  tables: true
});

// Function to render markdown with custom styles
const renderMarkdown = (markdown) => {
  if (!markdown) return "";
  return md.render(markdown);
};

const InnerChat = (props) => {
  const authToken = props.authToken
  const [apiDisclaimer, setApiDisclaimer] = useState("");
  let { id } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const listingRef = useRef(null);
  const wsURL = null; // legacy constant not used with dynamic env helpers
  const [flag, setFlag] = useState(false);
  const [newPrompt, setNewPrompt] = useState({is_writing:false ,answer:"", block_id: null,prompt: ""});
  const [question, setQuestion] = useState("");
  const [transitionFlag, setTransitionFlag] = useState(false);
  const [message, setMessage] = useState({is_writing:false,answer:"",block_id: null,prompt: ""});
  const [resourcePopupData, setResourcePopupData] = useState(null);
  const [currentResourceType, setCurrentResourceType] = useState("");
  const [currentQuestion, setCurrentQuestion] = useState("");
  const [linkShow, setLinkShow] = useState(false);  
  const isLoadings = useSelector((state) => state.queryzoi.ama_loading);
  const main_loading = useSelector((state) => state.queryzoi.loading);
  const chat_listing = useSelector((state) => state.queryzoi.chat_listing?.details);
  const docsDetails = useSelector((state) => state.queryzoi?.canned_docs);
  const num_client_id = useSelector((state) => state.assetLibrary?.userData?.new_client_id);
  const [showOverlay, setShowOverlay] = useState(false);
  const [searchCanned, setSearchCanned] = useState("");
  // Pdf Preview 
  const [showPreviewer, setShowPreviewer] = useState(false);
  const [previewData, setPreviewData] = useState("");

  // Calendar
  const [calendarCounter, setCalendarCounter] = useState(0);
  const [timeSelected, setTimeSelected] = useState("");
  const [showMeeting, setShowMeeting] = useState(false);
  const [showAgent, setShowAgent] = useState(false);
  const [showAgentCounter, setShowAgentCounter] = useState(0);
  const [currentSliderQuestion, setCurrentSliderQuestion] = useState("What are some use cases for Salespanda in financial services ?");
  const [thinkingMessage, setThinkingMessage] = useState(0);
  const chat_history = useSelector((state) => state.queryzoi.chat_history);

  const inputRef = useRef(null);

  // Speech-to-text related states and refs
  const [isRecording, setIsRecording] = useState(false);
  const [transcribedText, setTranscribedText] = useState("");
  const [microphonePermission, setMicrophonePermission] = useState('unknown');
  const [sessionId, setSessionId] = useState(null);
  const [isConnected, setIsConnected] = useState(false);
  const [detectedLanguage, setDetectedLanguage] = useState(null);
  
  // Audio processing refs
  const audioSocketRef = useRef(null);
  const audioContextRef = useRef(null);
  const audioStreamRef = useRef(null);
  const audioProcessorRef = useRef(null);
  const audioSourceRef = useRef(null);
  const isRecordingRef = useRef(false);

  // AI thinking process messages
  const thinkingMessages = [
    "Analyzing your question...",
    "Searching through knowledge base...",
    "Processing relevant information...",
    "Connecting related concepts...",
    "Evaluating different perspectives...",
    "Synthesizing insights...",
    "Generating comprehensive response...",
    "Finalizing answer structure...",
    "Almost ready with your answer..."
  ];

  // Audio streaming states and refs
  const [isAudioMuted, setIsAudioMuted] = useState(false);
  const [isAudioPlaying, setIsAudioPlaying] = useState(false);
  const [isChatStreamConnected, setIsChatStreamConnected] = useState(false);
  const [isAudioResponseConnected, setIsAudioResponseConnected] = useState(false);
  const [audioSessionId, setAudioSessionId] = useState(null);
  const [isAudioQueueCompleted, setIsAudioQueueCompleted] = useState(false);
  
  // Audio streaming refs
  const chatStreamSocketRef = useRef(null);
  const audioResponseSocketRef = useRef(null);
  const audioStreamQueue = useRef([]);
  const isProcessingAudio = useRef(false);
  const currentAudioSource = useRef(null);
  
  // Track if sockets have been connected for initial prompt
  const initialPromptSocketsConnected = useRef(false);

  // URL-based: show disclaimer on allowed URLs when path contains internal_ama
  // Allowed: localhost:3000, 127.0.0.1:3000, dev.askzoi.com, sia.salespanda.com
  const isAllowedOrigin = () => {
    if (typeof window === 'undefined') return false;
    const { hostname, port, pathname } = window.location;
    const isInternalAma = pathname.includes('internal_ama');
    return isInternalAma;
    if (!isInternalAma) return false;
    const isLocalhost = (hostname === 'localhost' || hostname === '127.0.0.1') && (port === '3000' || port === '');
    const isDevAskzoi = hostname === 'dev.askzoi.com';
    const isSiaSalespanda = hostname === 'sia.salespanda.com';
    return isLocalhost || isDevAskzoi || isSiaSalespanda;
  };
  const showDisclaimer = isAllowedOrigin();

  useEffect(() => {
    const loadDisclaimer = async () => {
      if (!authToken) return;
      try {
        const res = await getCustomerBranding(authToken);
        if (res?.data?.statusCode === "200") {
          setApiDisclaimer(res?.data?.data?.disclaimer || "");
        }
      } catch (_) {
        setApiDisclaimer("");
      }
    };
    loadDisclaimer();
  }, [authToken]);

  // Auto-resize textarea
  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.style.height = 'auto';
      inputRef.current.style.height = Math.min(inputRef.current.scrollHeight, 120) + 'px';
    }
  }, [question]);

  // Rotate thinking messages
  useEffect(() => {
    let interval;
    if (isLoadings && message?.is_writing !== true && message?.answer === "") {
      interval = setInterval(() => {
        setThinkingMessage((prev) => (prev + 1) % thinkingMessages.length);
      }, 2000); // Change message every 2 seconds
    } else {
      setThinkingMessage(0);
    }

    return () => {
      if (interval) clearInterval(interval);
    };
  }, [isLoadings, message?.is_writing, message?.answer]);

  // Check microphone permissions on component mount
  useEffect(() => {
    checkMicrophonePermissions();
  }, []);

  // Monitor audio queue status changes
  useEffect(() => {
    if (isAudioQueueCompleted) {
      console.log('🎉 Audio queue completion state changed to true');
      // You can add additional logic here when the completion state changes
    }
  }, [isAudioQueueCompleted]);

  // Function to check microphone permissions
  const checkMicrophonePermissions = async () => {
    try {
      if (navigator.permissions) {
        const permissionStatus = await navigator.permissions.query({ name: 'microphone' });
        setMicrophonePermission(permissionStatus.state);
        console.log('Microphone permission status:', permissionStatus.state);
        
        permissionStatus.onchange = () => {
          setMicrophonePermission(permissionStatus.state);
          console.log('Microphone permission changed to:', permissionStatus.state);
        };
      } else {
        console.log('Permissions API not supported');
        setMicrophonePermission('unsupported');
      }
    } catch (error) {
      console.error('Error checking microphone permissions:', error);
      setMicrophonePermission('error');
    }
  };

  // Create session with the new Saaras API
  const createSession = async () => {
    try {
      console.log('📡 Creating Saaras session...');
      
      const response = await axios.post(
        speechToTextUrl(),
        { "user": "1"},
        {
          headers: {
            Accept: "application/json", 
            Authorization: `Bearer ${authToken}`,
          },
        }
      );

      if (response.status === 200 && response.data.status === 'success') {
        const newSessionId = response.data.session_id;
        setSessionId(newSessionId);
        console.log(`✅ Session created: ${newSessionId}`);
        return newSessionId;
      } else {
        throw new Error(response.data.message || 'Session creation failed');
      }
    } catch (error) {
      console.error('❌ Session creation error:', error);
      throw error;
    }
  };

  // WebSocket connection for Saaras API
  const connectWebSocket = async (sessionId) => {
    try {
      const wsURL = wsSpeech(sessionId);
      console.log(`🔗 Connecting to WebSocket: ${wsURL}`);

      const audioSocket = new WebSocket(wsURL);
      
      audioSocket.onopen = () => {
        console.log("✅ WebSocket connected");
        setIsConnected(true);
        audioSocketRef.current = audioSocket;
      };

      audioSocket.onmessage = (event) => {
        try {
          const data = JSON.parse(event.data);
          handleWebSocketMessage(data);
        } catch (error) {
          console.error('Error parsing WebSocket message:', error);
        }
      };

      audioSocket.onerror = (error) => {
        console.error('❌ WebSocket error:', error);
        setTimeout(() => {
          connectWebSocket(sessionId);
        }, 1000);
        setIsConnected(false);
      };

      audioSocket.onclose = () => {
        console.log("🔌 WebSocket disconnected");
        setIsConnected(false);
        audioSocketRef.current = null;
      };

      return audioSocket;
    } catch (error) {
      setTimeout(() => {
        connectWebSocket(sessionId);
      }, 1000); 
      console.error('❌ WebSocket connection error:', error);
      throw error;
    }
  };

  // Handle WebSocket messages from new Saaras API
  const handleWebSocketMessage = (data) => {
    console.log(`📨 Received: ${data.type} - ${data.message || ''}`);

    switch (data.type) {
      case 'websocket_connected':
        console.log(`🎉 Connected to session: ${data.session_id}`);
        break;

      case 'recording_started':
        console.log("🔴 Recording with Saaras v2.5 streaming...");
        break;

      case 'speech_start':
        console.log("🎤 Speech detected");
        break;

      case 'speech_end':
        console.log("⏸️ Speech ended");
        break;

      case 'language_detected':
        setDetectedLanguage(data.language);
        console.log(`🌐 Language detected: ${data.language} (${data.language_code})`);
        break;

      case 'streaming_transcript':
        const liveText = data.full_transcript || data.transcript;
        setTranscribedText(liveText);
        setQuestion(liveText);
        
        // Adjust textarea height
        if (inputRef.current) {
          const textarea = inputRef.current;
          const scrollTop = textarea.scrollTop;
          textarea.style.height = 'auto';
          const scrollHeight = textarea.scrollHeight;
          const newHeight = liveText === '' ? 76 : Math.min(scrollHeight, 120);
          textarea.style.height = newHeight + 'px';
          textarea.scrollTop = scrollTop;
        }
        console.log(`📝 Live: ${data.transcript}`);
        break;

      case 'recording_stopped':
        console.log("⏹️ Recording stopped - Processing...");
        break;

      case 'transcription_result':
        const finalText = data.transcript;
        setTranscribedText(finalText);
        setQuestion(finalText);
        console.log(`🎯 Final result: ${finalText}`);
        if (data.streaming_source) {
          console.log("⚡ Result from Saaras streaming");
        }
        break;

      case 'streaming_error':
      case 'transcription_error':
        console.error(`❌ Error: ${data.message || data.error}`);
        break;

      case 'chunk_received':
        // Silent - too frequent for UI
        break;

      default:
        console.log(`❓ Unknown message type: ${data.type}`);
    }
  };

  // Speech-to-text functions - Updated for new Saaras API
  const startRecording = async () => {
    try {
      console.log('🎤 Starting Saaras speech recognition...');
      
      // Check if navigator.mediaDevices is available
      if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
        throw new Error('getUserMedia is not supported in this browser');
      }

      // Check if we're on HTTPS or localhost
      if (window.location.protocol !== 'https:' && window.location.hostname !== 'localhost' && window.location.hostname !== '127.0.0.1') {
        throw new Error('Microphone access requires HTTPS or localhost');
      }

      console.log('Requesting microphone permission...');
       
      // Request microphone permission with specific constraints for raw audio
      const stream = await navigator.mediaDevices.getUserMedia({ 
        audio: {
          sampleRate: 16000,
          channelCount: 1,
          echoCancellation: true,
          noiseSuppression: true
        } 
      });
      
      console.log('Microphone access granted, creating session...');

      // Create session and connect WebSocket (server doesn't support Socket.IO)
      const newSessionId = await createSession();
      
      // Use WebSocket directly since server doesn't support Socket.IO
      const audioSocket = await connectWebSocket(newSessionId);
      console.log('✅ Using WebSocket connection (server doesn\'t support Socket.IO)');
      
      // Wait for WebSocket to be ready
      if (audioSocket.readyState !== WebSocket.OPEN) {
        await new Promise((resolve, reject) => {
          const timeout = setTimeout(() => reject(new Error('WebSocket connection timeout')), 5000);
          audioSocket.onopen = () => {
            clearTimeout(timeout);
            resolve();
          };
        });
      }

      // Send start recording message
      audioSocket.send(JSON.stringify({ type: 'start_recording' }));

      // Create AudioContext for raw audio processing
      const audioContext = new (window.AudioContext || window.webkitAudioContext)({
        sampleRate: 16000
      });
      
      const source = audioContext.createMediaStreamSource(stream);
      
      // Create ScriptProcessorNode for raw audio capture
      const processor = audioContext.createScriptProcessor(1024, 1, 1);
      
      processor.onaudioprocess = (event) => {
        if (audioSocket && audioSocket.readyState === WebSocket.OPEN && isRecordingRef.current) {
          const inputData = event.inputBuffer.getChannelData(0);
          
          // Convert float32 to int16 PCM
          const int16Array = new Int16Array(inputData.length);
          for (let i = 0; i < inputData.length; i++) {
            int16Array[i] = Math.max(-32768, Math.min(32767, Math.floor(inputData[i] * 32767)));
          }
          
          // Convert to base64 byte stream (like HTML template)
          const arrayBuffer = int16Array.buffer;
          const uint8Array = new Uint8Array(arrayBuffer);
          let binary = '';
          for (let i = 0; i < uint8Array.byteLength; i++) {
            binary += String.fromCharCode(uint8Array[i]);
          }
          const base64Data = btoa(binary);
          
          // Send via WebSocket
          audioSocket.send(JSON.stringify({
            type: 'audio_chunk',
            audio_data: base64Data
          }));
        }
      };

      source.connect(processor);
      processor.connect(audioContext.destination);
      
      // Store references for cleanup
      audioContextRef.current = audioContext;
      audioProcessorRef.current = processor;
      audioSourceRef.current = source;
      audioStreamRef.current = stream;
      isRecordingRef.current = true;
      setIsRecording(true);
      
      console.log('✅ Saaras speech recognition started successfully');

    } catch (err) {
      console.error("Error starting speech recognition:", err);
      
      // Provide specific error messages
      if (err.name === 'NotAllowedError') {
        console.log("Microphone access denied. Please allow microphone access and try again.", "E");
      } else if (err.name === 'NotFoundError') {
        console.log("No microphone found. Please connect a microphone and try again.", "E");
      } else if (err.name === 'NotSupportedError') {
        console.log("Microphone is not supported in this browser.", "E");
      } else if (err.name === 'NotReadableError') {
        console.log("Microphone is being used by another application.", "E");
      } else if (err.message.includes('HTTPS')) {
        console.log("Microphone access requires HTTPS. Please use a secure connection.", "E");
      } else {
        console.log(`Speech recognition error: ${err.message}`, "E");
      }
    }
  };

  const stopRecording = () => {
    console.log('⏹️ Stopping Saaras speech recognition...');
    
    isRecordingRef.current = false;
    setIsRecording(false);
    
    // Send stop recording message
    if (audioSocketRef.current && audioSocketRef.current.readyState === WebSocket.OPEN) {
      audioSocketRef.current.send(JSON.stringify({ type: 'stop_recording' }));
      console.log('Sent stop_recording message to server');
    }
    
    // Clean up AudioContext and processor
    if (audioProcessorRef.current) {
      audioProcessorRef.current.disconnect();
      audioProcessorRef.current = null;
    }
    
    if (audioSourceRef.current) {
      audioSourceRef.current.disconnect();
      audioSourceRef.current = null;
    }
    
    if (audioContextRef.current) {
      audioContextRef.current.close();
      audioContextRef.current = null;
    }
    
    // Stop all audio tracks
    if (audioStreamRef.current) {
      audioStreamRef.current.getTracks().forEach(track => {
        track.stop();
        console.log('Stopped audio track:', track);
      });
      audioStreamRef.current = null;
    }
    
    console.log('🛑 Saaras speech recognition stopped successfully');
  };

  const toggleRecording = () => {
    if (isRecordingRef.current) {
      stopRecording();
    } else {
      startRecording();
    }
  };

  // Test microphone access function for debugging
  const testMicrophoneAccess = async () => {
    try {
      console.log('Testing microphone access...');
      console.log('Browser:', navigator.userAgent);
      console.log('Location protocol:', window.location.protocol);
      console.log('Hostname:', window.location.hostname);
      
      if (!navigator.mediaDevices) {
        console.error('navigator.mediaDevices not available');
        return;
      }

      if (!navigator.mediaDevices.getUserMedia) {
        console.error('getUserMedia not available');
        return;
      }

      const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
      console.log('Microphone access successful!', stream);
      
      // Stop the test stream
      stream.getTracks().forEach(track => {
        track.stop();
        console.log('Stopped track:', track);
      });
      
      // Update permission status
      setMicrophonePermission('granted');
      
    } catch (error) {
      console.error('Microphone test failed:', error);
      console.error('Error name:', error.name);
      console.error('Error message:', error.message);
      
      if (error.name === 'NotAllowedError') {
        setMicrophonePermission('denied');
      }
    }
  };


  // Chat Stream Socket Connection
  const connectChatStreamSocket = async (sessionId) => {
    try {
      const wsURL = wsChatStream(sessionId);
      console.log(`🔗 Connecting to Chat Stream WebSocket: ${wsURL}`);

      const chatSocket = new WebSocket(wsURL);
      
      const handleOpen = (event) => {
        console.log('✅ Chat Stream WebSocket connected');
        setIsChatStreamConnected(true);
        chatStreamSocketRef.current = chatSocket;
      };

      const handleMessage = (event) => {
        try {
          const data = JSON.parse(event.data);
          let objAnswer = {
            answer: data[data.length - 1]?.answer,
            block_id: null,
            is_writing: data[data.length - 1].is_writing,
            prompt: data[data.length - 1].prompt
          };
          setMessage(objAnswer);
          

        } catch (error) {
          console.error('Error parsing Chat Stream message:', error);
        }
      };

      const handleError = (error) => {
        console.error('❌ Chat Stream WebSocket error:', error);
        setIsChatStreamConnected(false);
        connectChatStreamSocket(sessionId);
      };

      const handleClose = () => {
        console.log("🔌 Chat Stream WebSocket disconnected");
        setIsChatStreamConnected(false);
        chatStreamSocketRef.current = null;
      };

      chatSocket.addEventListener('open', handleOpen);
      chatSocket.addEventListener('message', handleMessage);
      chatSocket.addEventListener('error', handleError);
      chatSocket.addEventListener('close', handleClose);

      return chatSocket;
    } catch (error) {
      console.error('❌ Chat Stream WebSocket connection error:', error);
      throw error;
    }
  };

  // Audio Response Socket Connection
  const connectAudioResponseSocket = async (sessionId) => {
    try {
      const wsURL = wsAudioBase64(sessionId);
      console.log(`🔗 Connecting to Audio Response WebSocket: ${wsURL}`);

      const audioSocket = new WebSocket(wsURL);
      
      const handleOpen = async (event) => {
        console.log('✅ Audio Response WebSocket connected');
        setIsAudioResponseConnected(true);
        audioResponseSocketRef.current = audioSocket;
        
        // Initialize audio context for streaming (iOS compatible)
        // Wait for audio context to be fully ready before proceeding
        try {
          await initAudioContext();
          console.log('🎵 Audio context initialized and ready');
          // Small delay to ensure audio context is fully ready on iOS
          await new Promise(resolve => setTimeout(resolve, 100));
        } catch (error) {
          console.error('Failed to initialize audio context:', error);
        }
      };

      const handleMessage = (event) => {
        try {
          const data = JSON.parse(event.data);
          console.log(`🎵 Received audio data: ${JSON.stringify(data, null, 2)}`);
          
          if (data.type === 'audio_base64' && data.audio_base64) {
            // Reset completion state when new audio is added
            setIsAudioQueueCompleted(false);
            
            // Add audio chunk to queue
            audioStreamQueue.current.push({
              data: data.audio_base64,
              timestamp: Date.now(),
              format: data.format || 'mp3',
              sequence: data.sequence || 0
            });
            
            // Process audio queue if not already processing
            if (!isProcessingAudio.current && !isAudioMuted) {
              processAudioQueue();
            }
          }
        } catch (error) {
          console.error('Error parsing Audio Response message:', error);
        }
      };

      const handleError = (error) => {
        console.error('❌ Audio Response WebSocket error:', error);
        setIsAudioResponseConnected(false);
        connectAudioResponseSocket(sessionId);
      };

      const handleClose = (event) => {
        console.log(`🔌 Audio Response WebSocket disconnected: ${event.code} - ${event.reason}`);
        setIsAudioResponseConnected(false);
        audioResponseSocketRef.current = null;
      };

      audioSocket.addEventListener('open', handleOpen);
      audioSocket.addEventListener('message', handleMessage);
      audioSocket.addEventListener('error', handleError);
      audioSocket.addEventListener('close', handleClose);

      return audioSocket;
    } catch (error) {
      console.error('❌ Audio Response WebSocket connection error:', error);
      throw error;
    }
  };

  // Process audio streaming queue
  const processAudioQueue = async () => {
    if (isProcessingAudio.current || audioStreamQueue.current.length === 0 || isAudioMuted) {
      return;
    }

    // Ensure audio context is initialized for iOS compatibility
    try {
      await initAudioContext();
    } catch (error) {
      console.error('Failed to initialize audio context in processAudioQueue:', error);
      return;
    }

    isProcessingAudio.current = true;
    setIsAudioPlaying(true);

    try {
      while (audioStreamQueue.current.length > 0 && !isAudioMuted) {
        const audioChunk = audioStreamQueue.current.shift();
        await playAudioChunk(audioChunk);
      }
      
      // All audio in queue has finished playing
      console.log('🎵 All audio in queue has finished playing');
      onAllAudioFinished();
    } catch (error) {
      console.error('Error processing audio queue:', error);
    } finally {
      isProcessingAudio.current = false;
      setIsAudioPlaying(false);
    }
  };

  // Callback function when all audio finishes playing
  const onAllAudioFinished = () => {
    console.log('🎵 All audio finished playing, closing previous sockets...');
    
    // Close audio response socket if connected
    if (audioResponseSocketRef.current && audioResponseSocketRef.current.readyState === WebSocket.OPEN) {
      console.log('🔌 Closing audio response socket...');
      audioResponseSocketRef.current.close();
      audioResponseSocketRef.current = null;
    }
    
    // Close chat stream socket if connected
    if (chatStreamSocketRef.current && chatStreamSocketRef.current.readyState === WebSocket.OPEN) {
      console.log('🔌 Closing chat stream socket...');
      chatStreamSocketRef.current.close();
      chatStreamSocketRef.current = null;
    }
    
    // Close main audio socket if connected
    if (audioSocketRef.current && audioSocketRef.current.readyState === WebSocket.OPEN) {
      console.log('🔌 Closing main audio socket...');
      audioSocketRef.current.close();
      audioSocketRef.current = null;
    }
    
    // Reset connection states
    setIsChatStreamConnected(false);
    setIsAudioResponseConnected(false);
    
    console.log('✅ All previous sockets closed successfully');
  };

  // Utility function to get current audio queue status
  const getAudioQueueStatus = () => {
    return {
      isPlaying: isAudioPlaying,
      isCompleted: isAudioQueueCompleted,
      isMuted: isAudioMuted,
      queueLength: audioStreamQueue.current.length,
      isProcessing: isProcessingAudio.current
    };
  };

  // Function to manually check if queue is empty and trigger completion
  const checkQueueCompletion = () => {
    if (audioStreamQueue.current.length === 0 && !isProcessingAudio.current && isAudioPlaying) {
      console.log('🎵 Queue is empty, triggering completion callback');
      onAllAudioFinished();
    }
  };

  // Function to reset audio queue completion state
  const resetAudioQueueCompletion = () => {
    setIsAudioQueueCompleted(false);
    console.log('🔄 Audio queue completion state reset');
  };

  // Play individual audio chunk using iOS-compatible utility
  const playAudioChunk = async (audioChunk) => {
    try {
      return await playAudioChunkUtil(audioChunk, isAudioMuted);
    } catch (error) {
      console.error('Error in playAudioChunk:', error);
      throw error;
    }
  };

  // Disconnect chat stream socket
  const disconnectChatStreamSocket = () => {
    console.log('🔌 Disconnecting chat stream socket...');
    
    if (chatStreamSocketRef.current) {
      chatStreamSocketRef.current.removeEventListener('open', () => {});
      chatStreamSocketRef.current.removeEventListener('message', () => {});
      chatStreamSocketRef.current.removeEventListener('error', () => {});
      chatStreamSocketRef.current.removeEventListener('close', () => {});
      chatStreamSocketRef.current.close();
      chatStreamSocketRef.current = null;
    }
    
    setIsChatStreamConnected(false);
    console.log('🔌 Chat stream socket disconnected');
  };

  // Disconnect audio response socket
  const disconnectAudioResponse = () => {
    console.log('🔌 Disconnecting audio response socket...');
    
    // Stop current audio playback
    if (currentAudioSource.current) {
      currentAudioSource.current.pause();
      currentAudioSource.current = null;
    }
    
    // Clear audio queue
    audioStreamQueue.current = [];
    isProcessingAudio.current = false;
    setIsAudioPlaying(false);
    setIsAudioQueueCompleted(false);
    
    // Close audio response socket
    if (audioResponseSocketRef.current) {
      audioResponseSocketRef.current.removeEventListener('open', () => {});
      audioResponseSocketRef.current.removeEventListener('message', () => {});
      audioResponseSocketRef.current.removeEventListener('error', () => {});
      audioResponseSocketRef.current.removeEventListener('close', () => {});
      audioResponseSocketRef.current.close();
      audioResponseSocketRef.current = null;
    }
    
    // Close audio context using utility
    cleanupAudioContext();
    
    setIsAudioResponseConnected(false);
    console.log('🔌 Audio response socket disconnected');
  };

  // Clear previous audio data
  const clearPreviousAudioData = () => {
    console.log('🧹 Clearing previous audio data...');
    console.log('📋 Called from:', new Error().stack?.split('\n')[2]?.trim() || 'unknown location');
    
    // Stop current audio playback
    if (currentAudioSource.current) {
      currentAudioSource.current.pause();
      currentAudioSource.current = null;
    }
    
    // Clear audio queue
    audioStreamQueue.current = [];
    isProcessingAudio.current = false;
    setIsAudioPlaying(false);
    setIsAudioQueueCompleted(false);
    
    // Disconnect existing audio socket if connected
    if (audioResponseSocketRef.current) {
      audioResponseSocketRef.current.close();
      audioResponseSocketRef.current = null;
    }
    
    setIsAudioResponseConnected(false);
    console.log('✅ Previous audio data cleared');
  };

  // Connect both sockets when prompt is submitted
  const connectBothSockets = async () => {
    try {
      if (!id) {
        console.error('❌ No session ID available for socket connections');
        return;
      }

      console.log('🚀 Connecting both chat stream and audio response sockets...');
      console.log('📋 Session ID:', id);
      console.log('📋 Called from:', new Error().stack?.split('\n')[2]?.trim() || 'unknown location');
      
      // Clear previous audio data first
      clearPreviousAudioData();
      
      // Connect chat streaming socket
      await connectChatStreamSocket(id);
      
      // Connect audio response socket
      setAudioSessionId(id);
      await connectAudioResponseSocket(id);
      
      console.log('✅ Both sockets connected successfully');
      
    } catch (error) {
      console.error('❌ Failed to connect sockets:', error);
      throw error; // Re-throw to allow calling code to handle
    }
  };

  // Toggle audio mute/unmute
  const toggleAudioMute = async () => {
    setIsAudioMuted(!isAudioMuted);
    
    if (!isAudioMuted) {
      if (currentAudioSource.current) {
        currentAudioSource.current.pause();
        currentAudioSource.current = null;
      }
      disconnectAudioResponse();
      isProcessingAudio.current = false;
      setIsAudioPlaying(false);
      console.log('🔇 Audio muted');
    } else {
      // Unmuting - resume processing if there are queued chunks
      console.log('🔊 Audio unmuted');
      
      // Initialize audio context if not already done (iOS compatibility)
      try {
        await initAudioContext();
      } catch (error) {
        console.error('Failed to initialize audio context in toggleAudioMute:', error);
        return;
      }
      
      if (audioStreamQueue.current.length > 0) {
        processAudioQueue();
      }
    }
  };



  // Cleanup on component unmount
  // useEffect(() => {
  //   return () => {
  //     if (isRecordingRef.current) {
  //       stopRecording();
  //     }
      
  //     // Close WebSocket connection
  //     if (audioSocketRef.current) {
  //       audioSocketRef.current.close();
  //       console.log('WebSocket connection closed on unmount');
  //     }
      
  //     // Additional cleanup for audio context
  //     if (audioContextRef.current && audioContextRef.current.state !== 'closed') {
  //       audioContextRef.current.close();
  //       console.log('Audio context closed on unmount');
  //     }

  //     // Cleanup streaming sockets and audio
  //     disconnectBothSockets();
      
  //     // Reset initial prompt socket connection flag
  //     initialPromptSocketsConnected.current = false;
  //   };
  // }, []);



  const handleTimeSelection = (item) => {
    setTimeSelected(item);
    // alert(index)
  };

  const handleCalendarNext = () => {
    if (calendarCounter === 0) {
      setCalendarCounter(calendarCounter + 1);
    }
    if (calendarCounter === 1 && timeSelected?.length > 0) {
      setCalendarCounter(calendarCounter + 1);
    }
    if (calendarCounter === 2) {
      setCalendarCounter(calendarCounter + 1);
        setTimeout(() => {
          setShowMeeting(false);
          setCalendarCounter(0);
        }, 2000);
    }
  };
  const handleCalendarBack = () => {
    setCalendarCounter(calendarCounter - 1);
  };

  const maxDate = new Date();

  const timeSlots =[
    "09:00 AM",
    "09:15 AM",
    "09:30 AM",
    "09:45 AM",
    "10:00 AM",
    "10:15 AM",
    "10:30 AM",
    "10:45 AM",
    "11:00 AM",
    "11:15 AM",
    "11:30 AM",
    "11:45 AM",
    "12:00 PM",
    "12:15 PM",
    "12:30 PM",
    "12:45 PM",
    "01:00 PM",
    "01:15 PM",
    "01:30 PM",
    "01:45 PM",
    "02:00 PM",
    "02:15 PM",
    "02:30 PM",
    "02:45 PM",
    "03:00 PM",
    "03:15 PM",
    "03:30 PM",
    "03:45 PM",
    "04:00 PM",
    "04:15 PM",
    "04:30 PM",
    "04:45 PM",
    "05:00 PM",
    "05:15 PM",
    "05:30 PM",
    "05:45 PM",
    "07:00 PM",
    "07:15 PM",
    "07:30 PM",
    "07:45 PM"
]

  // Calendar



  const handleShowPreviewer = (data) => {
    console.log(data,"data")
    setPreviewData(data)
    setShowPreviewer(true);
    setShowOverlay(false);
    setQuestion("")
  }
  
  const handleHidePreviewer = (data) => {
    setPreviewData("")
    setShowPreviewer(false);
  }

  //Pdf Preview

  
  useEffect(() => {
    dispatch(fetchChatHistoryListing(authToken));
    if (id !== "") {
      dispatch(fetchMainChatListing(authToken, id, "main", onSuccessResponse));
      // Reset initial prompt socket connection flag for new session
      initialPromptSocketsConnected.current = false;
    }
  }, [id])
  
  useEffect(() => {
    if (props.initQuestion != "") {
      let obj = {
          block_id: null,
          is_writing: false,
          prompt: props.initQuestion,
          answer: ""
      }
      setNewPrompt(obj);
      handleSubmit(props.initQuestion);
    }
  }, [id])

  // Firebase
  // useEffect(() => {
  //   const crawlingRef = ref(
  //     db,
  //     `/users/${num_client_id}/chat/${id}/conversation`
  //   );
  //   const onIdStatusChange = onValue(crawlingRef, (snapshot) => {
  //     const idStatus = snapshot.val();
  //     if (idStatus !== null && idStatus[idStatus?.length - 1]?.is_writing !== false) {
  //       let objAnswer = {
  //         answer: idStatus[idStatus.length - 1].answer,
  //         block_id: idStatus[idStatus.length - 1].block_id,
  //         is_writing: idStatus[idStatus.length - 1].is_writing,
  //         prompt: idStatus[idStatus.length - 1].prompt
  //       }
  //       setMessage(objAnswer);
  //     }
  //   });

  //   return () => {
  //     // Cleanup by detaching the listener when component unmounts
  //     onIdStatusChange();
  //   };
  // }, [isLoadings]);

  
  // Socket variables
//   useEffect(() => {
//     const socket = new WebSocket(`wss://app1.askzoi.com/socket_stream/${id}/`);
//     // Connection opened
//     socket.addEventListener('open', function (event) {
//       console.log('WebSocket connected');
//     });

//     // Listen for messages
//     socket.addEventListener('message', function (event) {
//         // console.log('Message from server:', event.data);
//         // Display incoming message in the chat box
//         const data =JSON.parse(event.data);
//         // setFMessage(data?.answer)
//         // setIsWriting(data?.is_writing)
//         // console.log(data?.answer,"answer")
//         // console.log(data,"write")
//         // appendMessage("Server Message =" + event.data);

//         let objAnswer = {
//                   answer: data[data.length - 1]?.answer,
//                   block_id: null,
//                   is_writing: data[data.length - 1].is_writing,
//                   prompt: data[data.length - 1].prompt
//                 }
//                 setMessage(objAnswer);
//     });

//     // Error handling
//     socket.addEventListener('error', function (error) {
//         console.error('WebSocket encountered error:', error);
//         setTimeout(() => {
//           socket = new WebSocket(`wss://dev1.askzoi.com/socket_stream/${id}/`);
//         }, 1000);
//     });

//     // return () => {
//     //     socket.close();
//     // };
// }, [id]);

  
  
  // Socket variables - Now handled by connectBothSockets when needed
  // Removed default connection to avoid conflicts with new streaming implementation
// Socket variables
  
//   useEffect(() => {
//     const pToken = Cookies.get("qzoi");
//     const socket = new WebSocket(`${wsURL}/${pToken}/`);
//     // Connection opened
//     socket.addEventListener('open', function (event) {
//     });
//     // Listen for messages
//     socket.addEventListener('message', function (event) {
//         // console.log('Message from server:', event.data);
//         // Display incoming message in the chat box
//         const data =JSON.parse(event.data);
//         // setFMessage(data?.answer)
//         // setIsWriting(data?.is_writing)
//         // console.log(data?.answer,"answer")
//         // console.log(data,"write")
//         // appendMessage("Server Message =" + event.data);
//         if (data !== null && data[data?.length - 1]?.is_writing !== false) {
//           let objAnswer = {
//             answer: data[data.length - 1].answer,
//             block_id: data[data.length - 1].block_id,
//             is_writing: data[data.length - 1].is_writing,
//             prompt: data[data.length - 1].prompt
//           }
//           setMessage(objAnswer);
//         }
//     });
//     // Error handling
//     socket.addEventListener('error', function (error) {
//         console.error('WebSocket encountered error:', error);
//     });
// }, []);
// // Socket variables
  
  useEffect(() => {
    // Scroll to bottom on initial load and whenever prompts change
      if (flag === true) {
        // setTimeout(() => {
          scrollToBottom();  
        // }, 500);
    }
  }, [flag]);

  const scrollToBottom = () => {
    // Scroll to bottom of the chat window with smooth transition
    const chatWindow = document.getElementById('chat-window');
    chatWindow.classList.add('scroll-smooth');
    chatWindow.scrollTop = chatWindow.scrollHeight;

    // Remove smooth scrolling class after transition
    setTimeout(() => {
      chatWindow.classList.remove('scroll-smooth');
    }, 500); // Adjust timing to match transition duration
  };
  
  function extractFileNameFromURL(url) {
    let startIndex = url.lastIndexOf("/") + 1; // Find the index of the last slash and add 1 to get the starting index of the file name
    let encodedFileName = url.substr(startIndex); // Extract the substring from the starting index to the end of the URL

    let fileName = decodeURIComponent(encodedFileName); // Decode the URL-encoded file name
    fileName = fileName.replace(".pdf", ""); // Remove the ".pdf" extension

    if (fileName.length > 12) {
      fileName = fileName.slice(0, 12); // Slice the file name to a maximum of 40 characters
    }

    return fileName;
  }
  
  const handleSuggestion = async (suggestion) => {
    if (suggestion.trim() !== "") {
      // Clear previous message state immediately to prevent showing stale answers
      setMessage({ is_writing: false, answer: "", block_id: null, prompt: "" });
      
      let obj = {
        block_id: null,
        is_writing: false,
        prompt: suggestion,
        answer: ""
      }
      setNewPrompt(obj);
      
      // Connect sockets when submitting suggestion
      await connectBothSockets();
      
      setTimeout(() => {
          setFlag(true);  
        }, 500);
      dispatch(addMessageQuery(authToken, suggestion, "200 to 300", id, onSuccessResponse))
      setQuestion("");
    }
  };

  const handleSuggestionReload = (p_id) => {
    dispatch(fetchNewSuggestion(authToken, id, p_id ,onSuccessResponse));
  };
  
  const openLinkInNewTab = (linkUrl) => {
    // Check if the URL has a protocol
    if (!linkUrl.startsWith("http://") && !linkUrl.startsWith("https://")) {
      // If not, prepend 'https://'
      linkUrl = "https://" + linkUrl;
    }

    window.open(linkUrl, "_blank");
  };
  
  const handleClipboard = (text) => {
    navigator.clipboard.writeText(text);
  };
  
  const onSuccessResponse = () => {
    setFlag(false);
    props.initialQuestion("");
    setTransitionFlag(true);
    setTimeout(() => {
      setTransitionFlag(false);
    }, 2000);
    setMessage({ is_writing: false, answer: "", block_id: null, prompt: "" });
    setNewPrompt({ is_writing: false, answer: "", block_id: null, prompt: "" });
    
    // Don't clear audio data - let it continue playing
    // This ensures that when API response completes instead of socket stream,
    // the audio continues playing until it naturally finishes
    // clearPreviousAudioData();
    console.log('🎵 API response completed - audio will continue playing');
  }

  const handleSubmit = async (passed_question) => {
    if(chat_listing?.length > 0){
      await disconnectAudioResponse();
    }
    if (passed_question.trim() !== "") {
      // Clear previous message state immediately to prevent showing stale answers
      setMessage({ is_writing: false, answer: "", block_id: null, prompt: "" });
      
      let obj = {
          block_id: null,
          is_writing: true,
          prompt: passed_question,
          answer: ""
      }
      setNewPrompt(obj);
      // Initialize audio context for iOS compatibility (must be called after user interaction)
      // Wait for audio context to be fully ready before proceeding
      try {
        await initAudioContext();
        console.log('🎵 Audio context initialized and ready');
        // Small delay to ensure audio context is fully ready on iOS
        await new Promise(resolve => setTimeout(resolve, 100));
      } catch (error) {
        console.error('Failed to initialize audio context:', error);
      }
      
      // Connect sockets when submitting prompt
      await connectBothSockets();
      if(chat_listing?.length > 0){
        await stopRecording();
      }
      setTimeout(() => {
          setFlag(true);  
        }, 500);
      dispatch(addMessageQuery(authToken, passed_question, "200 to 300", id, onSuccessResponse))
      setQuestion("");
    }
  };

  const handleLinks = (data, type) => {
    setResourcePopupData(data.meta_data);
    setCurrentQuestion(data.question)
    setCurrentResourceType(type);
    setLinkShow(true);
  };

  const linkRedirect = (url) => {
    window.open(url, "_blank");
  }
  
  const TooltipContent = (props) => {
    return (
      <div className="tooltip-content">
        <div
          // onClick={(e) =>
          //   handleLinks(item, "crawled_urls")
          // }
          className="border border-[var(--brand-primary)] max-sm:w-full shadow-md leading-[17px] px-2 py-1 rounded-md m-0"
        >
          <div className="mt-2">
            <div className="mr-1 mb-2 flex justify-between">
              <img
                className="w-6 h-6"
                src={props.doc.type == "web" ? props.doc?.favicon : PdfImage}
                alt="favicon"
              />
            </div>
          </div>
          <div className="pr-2 relative">
            <div
              className={`font-[600] text-[12px] text-[#373737] ${props.doc?.url_context ? "mb-0":"mb-3"}`}
              title={props.doc?.title}
            >{
                props.doc?.title
                  ?.length > 35
                  ? `${props.doc?.title.slice(
                      0,
                      30
                    )}..`
                  : `${props.doc?.title},`
              }
            </div>
            <div className="text-[10px] text-gray-600">
              {props.doc?.url_context
                ?.length > 80
                ? `${props.doc?.url_context?.slice(
                    0,
                    80
                  )}`
                : props.doc?.url_context}
            </div>
          </div>
        </div>
      </div>
    );
  };

  const handleCleanChat = () => {
    if (message.is_writing === false) {
        const expiryDate = new Date(Date.now() + 365 * 24 * 60 * 60 * 1000);
        const randomIdQuery = Math.floor(Math.random() * 900000) + 100000;
        Cookies.set("qzoi", `q-zoi-${randomIdQuery}`, { expires: expiryDate });
        dispatch(setListingData());
        setMessage({ is_writing: false, answer: "", block_id: null, prompt: "" })
        navigate(`/internal_ama`);
    }
  };

  // const [timer, setTimer] = useState(null);


  // useEffect(() => {
  //   // Clear the previous timer
  //   clearTimeout(timer);

  //   // Set a new timer
  //   const newTimer = setTimeout(() => {
  //     dispatch(fetchCannedListing(authToken, searchCanned));
  //   }, 500); // Adjust the delay here

  //   setTimer(newTimer);

  //   // Clean up function to clear timer in case component unmounts or searchCanned changes
  //   return () => clearTimeout(newTimer);
  // }, [searchCanned]);

  // const redirectLink = () => {

  // }
  
  
  const downloadPDF = (url) => {
    const link = document.createElement('a');
    link.href = url; // Replace this with your PDF URL
    link.download = 'filename.pdf'; // Replace "filename" with desired name of the file
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };
  
  const options = {
    overrides: {
      ul: {
        component: ({ children }) => <ul style={{ listStyleType: 'square', marginLeft: '30px' }}>{children}</ul>,
      },
      li: {
        component: ({ children }) => <li style={{ marginTop: '3px',marginBottom: '3px' }}>{children}</li>,
      },
      ol: {
        component: ({ children }) => <ol style={{ listStyleType: 'decimal', marginLeft: '20px',marginTop: '10px' }}>{children}</ol>,
      },
    },
  };

  // Expose audio queue tracking functions to parent component via ref or props
  // These functions can be called from the parent component to track audio queue status
  React.useImperativeHandle(props.audioQueueRef, () => ({
    getAudioQueueStatus,
    checkQueueCompletion,
    resetAudioQueueCompletion,
    isAudioQueueCompleted,
    isAudioPlaying,
    audioQueueLength: audioStreamQueue.current.length
  }), [isAudioQueueCompleted, isAudioPlaying]);

  // Prevent text selection and copying
  useEffect(() => {
    // Prevent context menu (right-click)
    const handleContextMenu = (e) => {
      e.preventDefault();
      return false;
    };

    // Prevent copy operations
    const handleCopy = (e) => {
      e.preventDefault();
      return false;
    };

    // Prevent cut operations
    const handleCut = (e) => {
      e.preventDefault();
      return false;
    };

    // Prevent keyboard shortcuts (Ctrl+C, Ctrl+A, Ctrl+X, etc.)
    const handleKeyDown = (e) => {
      // Prevent Ctrl+C, Ctrl+A, Ctrl+X, Ctrl+V
      if (e.ctrlKey && (e.key === 'c' || e.key === 'C' || e.key === 'a' || e.key === 'A' || e.key === 'x' || e.key === 'X' || e.key === 'v' || e.key === 'V')) {
        e.preventDefault();
        return false;
      }
      // Prevent F12 (Developer Tools)
      if (e.key === 'F12') {
        e.preventDefault();
        return false;
      }
    };

    // Prevent text selection
    const handleSelectStart = (e) => {
      // Allow selection in input/textarea elements
      if (e.target.tagName === 'INPUT' || e.target.tagName === 'TEXTAREA') {
        return true;
      }
      e.preventDefault();
      return false;
    };

    // Add event listeners
    document.addEventListener('contextmenu', handleContextMenu);
    document.addEventListener('copy', handleCopy);
    document.addEventListener('cut', handleCut);
    document.addEventListener('keydown', handleKeyDown);
    document.addEventListener('selectstart', handleSelectStart);

    // Cleanup
    return () => {
      document.removeEventListener('contextmenu', handleContextMenu);
      document.removeEventListener('copy', handleCopy);
      document.removeEventListener('cut', handleCut);
      document.removeEventListener('keydown', handleKeyDown);
      document.removeEventListener('selectstart', handleSelectStart);
    };
  }, []);

  return (
    <>
      <style>{`
        .chatBot,
        .chatBot * {
          -webkit-user-select: none !important;
          -moz-user-select: none !important;
          -ms-user-select: none !important;
          user-select: none !important;
          -webkit-touch-callout: none !important;
        }
        .chatBot input,
        .chatBot textarea {
          -webkit-user-select: text !important;
          -moz-user-select: text !important;
          -ms-user-select: text !important;
          user-select: text !important;
        }
      `}</style>
      <div
        className={`bg-white h-screen max-sm:h-screen rounded-t-3xl w-full chatBot pb-[5px] flex flex-col`}
        onContextMenu={(e) => e.preventDefault()}
        onCopy={(e) => e.preventDefault()}
        onCut={(e) => e.preventDefault()}
      >
    
        {/* </button> */}
        <div
          id="chat-window"
          className={`overflow-y-auto flex-1 messageContainer px-5 sm:px-5 max-sm:px-2 max-sm:pb-0 pb-[50px]`}
          ref={listingRef}
          onContextMenu={(e) => e.preventDefault()}
          onCopy={(e) => e.preventDefault()}
          onCut={(e) => e.preventDefault()}
        >
          
          {/* Side Overlay for more links */}
          <Transition.Root show={linkShow} as={Fragment}>
            <Dialog
              as="div"
              className="relative z-[9999]"
              onClose={setLinkShow}
            >
              <Transition.Child
                as={Fragment}
                enter="ease-in-out duration-500"
                enterFrom="opacity-0"
                enterTo="opacity-100"
                leave="ease-in-out duration-500"
                leaveFrom="opacity-100"
                leaveTo="opacity-0"
              >
                <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
              </Transition.Child>

              <div className="fixed inset-0 overflow-hidden ">
                <div className="absolute  inset-0 overflow-hidden ">
                  <div className="pointer-events-none fixed inset-y-0 right-0 flex max-w-full pl-10">
                    <Transition.Child
                      as={Fragment}
                      enter="transform transition ease-in-out duration-500 sm:duration-700"
                      enterFrom="translate-x-full"
                      enterTo="translate-x-0"
                      leave="transform transition ease-in-out duration-500 sm:duration-700"
                      leaveFrom="translate-x-0"
                      leaveTo="translate-x-full"
                    >
                                        <Dialog.Panel className="pointer-events-auto w-screen max-w-md max-sm:max-w-full">
                    <div
                      className={`flex bg-[#EFEFEF] h-full flex-col overflow-y-auto linkSlide py-3 max-sm:py-2 shadow-xl max-sm:pr-2`}
                    >
                          <div>
                            {/* <div className="flex">

                      </div> */}
                            <div
                              className="flex item-center justify-between px-6 max-sm:px-3 pb-4 max-sm:pb-3 border-b border-gray-300"
                            >
                              <div className="w-[60%] max-sm:w-[70%]">
                                <div
                                  className="font-[600] text-[var(--brand-primary)] text-2xl max-sm:text-xl"
                                >
                                  {currentResourceType === "crawled_urls" ? "Crawled URLs":"Documents"}
                                </div>
                                <p title={currentQuestion} className="truncate text-base max-sm:text-sm font-semibold">{currentQuestion}</p>
                              </div>
                              <div
                                // onClick={() => {
                                //   setLinkShow(false);
                                //   setLinkData([]);
                                // }}
                                className="grid space-y-2"
                              >
                                {resourcePopupData?.crawled_urls?.count > 0 && <span onClick={()=>{setCurrentResourceType("crawled_urls")}} className={`inline-flex h-6 cursor-pointer gap-2 items-center rounded-md  px-2 py-1 text-xs font-medium ring-1 ring-inset ${ currentResourceType === "crawled_urls" ? "bg-[var(--brand-primary)] text-white ring-[var(--brand-primary)]" : "bg-white text-[var(--brand-primary)] ring-[var(--brand-primary)]"}`}>
                                  Crawled Url
                                  <ChevronRight/>
                                </span>}
                                {resourcePopupData?.docs?.count > 0 && <span onClick={()=>{setCurrentResourceType("documents")}} className={`inline-flex w-min h-6 cursor-pointer gap-2 items-center rounded-md  px-2 py-1 text-xs font-medium ring-1 ring-inset ${ currentResourceType !== "crawled_urls" ? "bg-[var(--brand-primary)] text-white ring-[var(--brand-primary)]" : "bg-white text-[var(--brand-primary)] ring-[var(--brand-primary)]"}`}>
                                  Document
                                  <ChevronRight/>
                                </span>}
                                {/* <AiOutlineClose className="text-gray-300 cursor-pointer" /> */}
                              </div>
                            </div>

                            <div className="flex flex-col mt-2 overflow-y-auto h-[82vh] max-sm:h-[75vh] listing px-4 max-sm:px-2">
                              {currentResourceType === "crawled_urls" &&
                                resourcePopupData?.crawled_urls?.list?.map((linkItem, index) => {
                                  return (
                                    <>
                                      <div
                                        className="border border-gray-300 shadow-md leading-[17px] mr-[0.5rem] max-sm:mr-0 p-5 max-sm:p-3 rounded-md mb-2"
                                      >
                                        <div className="mb-2 flex justify-between">
                                          <img className="w-6 h-6 max-sm:w-5 max-sm:h-5" src={linkItem?.favicon} alt="panda"/>
                                          <div className="flex gap-2 max-sm:gap-1">
                                            <img className="cursor-pointer max-sm:w-4 max-sm:h-4" onClick={() => { handleClipboard(linkItem?.url) }} src={copyIco} alt="copy"/>
                                            <img className="cursor-pointer max-sm:w-4 max-sm:h-4" onClick={() => { openLinkInNewTab(linkItem?.url) }} src={shareIco} alt="send"/>
                                          </div>
                                        </div>
                                        <div className="w-full">
                                          <div
                                            onClick={(e) =>
                                              linkRedirect(linkItem?.url)
                                            }
                                            className="truncate font-semibold text-[var(--brand-primary)] cursor-pointer text-sm max-sm:text-xs"
                                            title={linkItem?.title}
                                          >
                                            { linkItem?.title }
                                          </div>
                                        </div>

                                        <div className="text-[10px] max-sm:text-[9px] text-gray-900 cursor-pointer" title={linkItem?.description}>
                                          {linkItem?.description?.length > 100 ? `${linkItem?.description?.slice(
                                                  0,
                                                  100
                                                )}...`:linkItem?.description}
                                        </div>
                                        <span className="grid justify-center cursor-pointer items-end bg-[var(--brand-primary)] text-[white] text-[8px] max-sm:text-[7px] h-4 w-4 max-sm:h-3 max-sm:w-3 border border-[var(--brand-primary)] rounded-full p-0">{linkItem?.rank}</span>
                                      </div>
                                    </>
                                  );
                                })
                              }
                              
                              {currentResourceType === "documents" &&
                                resourcePopupData?.docs?.list?.map((linkItem, index) => {
                                  return (
                                    <>
                                      <div
                                        className="border border-gray-300 shadow-md leading-[17px] mr-[0.5rem] max-sm:mr-0 p-5 max-sm:p-3 rounded-md mb-2"
                                      >
                                        <div className="mb-2 flex justify-between">
                                          <img className="w-6 h-6 max-sm:w-5 max-sm:h-5" src={PdfImage} alt="panda"/>
                                          <div className="flex gap-2 max-sm:gap-1">
                                            <img className="cursor-pointer max-sm:w-4 max-sm:h-4" onClick={() => { handleClipboard(linkItem?.url) }} src={copyIco} alt="copy"/>
                                            <img className="cursor-pointer max-sm:w-4 max-sm:h-4" onClick={() => { openLinkInNewTab(linkItem?.url) }} src={shareIco} alt="send"/>
                                          </div>
                                        </div>
                                        <div className="w-full">
                                          <div
                                            onClick={(e) =>
                                              linkRedirect(linkItem?.url)
                                            }
                                            className="truncate font-semibold text-[var(--brand-primary)] cursor-pointer text-sm max-sm:text-xs"
                                            title={linkItem?.title}
                                          >
                                            { linkItem?.title }
                                          </div>
                                        </div>

                                        <div className="text-[10px] max-sm:text-[9px] text-gray-900 cursor-pointer" title={linkItem?.description}>
                                          {linkItem?.description?.length > 100 ? `${linkItem?.description?.slice(
                                                  0,
                                                  100
                                                )}...`:linkItem?.description}
                                        </div>
                                        <span className="grid justify-center cursor-pointer items-end bg-[var(--brand-primary)] text-[white] text-[8px] max-sm:text-[7px] h-4 w-4 max-sm:h-3 max-sm:w-3 border border-[var(--brand-primary)] rounded-full p-0">{linkItem?.rank}</span>
                                      </div>
                                    </>
                                  );
                                })
                              }
                            </div>
                          </div>
                          <div className="relative mt-6 flex-1 px-4 sm:px-6">
                            {/* Your content */}
                          </div>
                        </div>
                      </Dialog.Panel>
                    </Transition.Child>
                  </div>
                </div>
              </div>
            </Dialog>
          </Transition.Root>
          {/* Side Overlay for more links */}
          {/* <div className='text-base fixed w-full z-[9] px-[25px] py-2.5 left-0 bg-white top-[65px] mb-4 flex items-center gap-2 font-semibold pt-1 text-[var(--brand-primary)] cursor-pointer'><ClockHistory className='text-2xl'/>Query Library</div> */}
          {/* Question */}
          {chat_listing && chat_listing.length > 0 ? (
            chat_listing.map((item, index) => {
              return (
                <div key={item?.id} className={`${(chat_listing.length !== index + 1 || (newPrompt && Object.keys(newPrompt).length > 0 && isLoadings === true)) ? "":"min-h-[65vh]"}`}>
                  {/* User bot Message */}
                  {/* User bot Message */}

                  {/* New struc messages + suggestion + Learn more */}
                  <div className="grid grid-cols-10 gap-x-8 max-sm:gap-x-2">
                    <div className="flex flex-col sm:col-span-9 max-sm:col-span-10">
                      <div className="flex zapUser">
                        <div
                          className={`py-[10px] max-sm:pt-0 max-sm:pb-3 w-[100%] text-left max-sm:mr-0 relative`}
                        >
                                                  <div
                          className={`text-gray-900 capitalize leading-[42px] max-sm:leading-[28px] max-sm:text-[18px] text-[20px] font-[600] max-sm:mb-0 mb-2 mt-6 max-sm:mt-3 fontClass`}
                          dangerouslySetInnerHTML={{
                            __html: item?.question,
                          }}
                        ></div>
                        </div>
                        {/* <img
                            src={userImg}
                            alt="arrow"
                            className="mb-auto w-[32px] h-[32px]"
                          /> */}
                      </div>
                      {/* Zap bot reply Message */}
                      <div className="zapBot">
                        <div
                          className={`pb-[20px] max-sm:pb-3 w-[100%] sm:w-[100%] text-left botMessageAMA`}
                        >
                          <div
                            className={`text-gray-600 leading-[22px] max-sm:leading-[20px] font-[500] text-[14px] max-sm:text-[13px] max-sm:mb-0 mb-2 fixWrap`}
                          >
                            <div className="markdown-content" dangerouslySetInnerHTML={{ __html: renderMarkdown(item?.answer) }} />
                          </div>
                          {item?.meta_data?.documents_used?.length > 0 && <div className="flex gap-2">
                            {item?.meta_data?.documents_used?.map((doc, d_ind) => {
                              return (
                                <>
                                  <a href={doc.url} target="blank" data-tooltip-id={"custom-tooltip-" + doc.rank + index} className="flex justify-center cursor-pointer items-end bg-[var(--brand-primary)] text-[white] text-[8px] h-4 w-4 border border-[var(--brand-primary)] rounded-full p-0">{doc.rank}</a>
                                  <Tooltip id={"custom-tooltip-" + doc.rank + index} place="right" effect="solid" >
                                    <TooltipContent doc={doc} crawlData={ item.meta_data?.crawled_urls?.list } docData={item.meta_data?.docs?.list} />
                                  </Tooltip>
                                </>
                              );
                            })}
                          </div>}
                        </div>
                       
                      </div>
                      {/* Zap bot reply Message */}
                      {/* Suggestion Flow */}
                      {
                        // showSuggestion &&
                        item?.suggestions?.length > 0 && (
                          <div className={`fontClass w-full mb-[1.25rem] max-sm:mb-3 ${(chat_listing.length === index+1 && transitionFlag === true) ? "slide-in-left":""}`}>
                            {item?.suggestions &&
                              item?.suggestions?.length > 0 && (
                                <div
                                  className="flex border-b border-gray-400 justify-between items-center gap-3 w-full my-auto max-sm:gap-2"
                                >
                                  <div className="flex items-center gap-3 max-sm:gap-2">
                                  <div>
                                    <FaList className="text-[var(--brand-primary)] max-sm:text-[16px]"
                                    />
                                  </div>
                                  <div
                                    className="text-[var(--brand-primary)] font-semibold text-[18px] max-sm:text-[16px]"
                                  >
                                    Related
                                  </div>
                                  </div>
                                  {item?.meta_data?.debug_url && (
                                    <div>
                                      <a 
                                        href={item.meta_data.debug_url} 
                                        target="_blank" 
                                        rel="noopener noreferrer"
                                        className="text-[var(--brand-primary)] hover:text-[#309A00] transition-colors"
                                      >
                                        <FaBug className="text-[18px]" />
                                      </a>
                                    </div>
                                  )}
                                </div>
                              )}
                            {item?.suggestions &&
                              item?.suggestions?.length > 0 &&
                              item?.suggestions.map((s_item, s_index) => {
                                return (
                                  <>
                                    {s_index < 3 && (
                                      <div
                                        className={`${
                                          s_index === 2 && "relative pr-4"
                                        }`}
                                      >
                                        <div
                                          onClick={() => {
                                            if (isLoadings !== true) {
                                              handleSuggestion(s_item);
                                            }
                                          }}
                                          className={`py-[0.5rem] cursor-pointer w-[92%] max-sm:w-full pr-[1rem] max-sm:pr-2 border-b-[1px] border-t-0 border-x-0 border-solid flex my-auto`}
                                        >
                                          <div className="mr-2 max-sm:mr-1">
                                            <CiCirclePlus className="text-[18px] max-sm:text-[16px]"/>
                                          </div>
                                          <div
                                            className={`font-[500] text-[13px] max-sm:text-[12px] leading-[15px] max-sm:leading-[14px] my-auto hover:text-[#49BCD2]`}
                                            // title={item}
                                          >
                                            {s_item?.length > 55
                                              ? `${s_item}`
                                              : s_item
                                            }
                                          </div>
                                        </div>
                                        {index === chat_listing?.length - 1 &&
                                          s_index === 2 && (
                                            <IoRefreshSharp
                                              onClick={() => {
                                                if (isLoadings !== true) {
                                                  handleSuggestionReload(item?.new_prompt_id)
                                                }
                                              }}
                                              className={`${
                                                main_loading ? "animate-spin" : ""
                                              } absolute bg-[var(--brand-primary)] text-white bottom-0 right-0 ml-4 mt-1 rounded-3xl cursor-pointer p-1 w-8 h-8`}
                                            />
                                          )}
                                      </div>
                                    )}
                                  </>
                                );
                              })}
                          </div>
                        )}
                      {/* Suggestion Flow */}
                    </div>

                    {item?.meta_data?.urls?.docs?.list?.length > 0 && <div className="flex flex-wrap text-lg max-sm:text-base text-semibold sm:col-span-10 max-sm:col-span-10 fontClass max-sm:ml-2">Recommended Documents</div>}
                    {/* Video and docs */}

                    <div className="flex flex-wrap sm:col-span-10 max-sm:col-span-10 ml-4 max-sm:ml-2 mt-3">{
                      item?.meta_data?.urls?.docs?.list?.map((doc, d_ind) => {
                        return (
                          <div className="flex-shrink-0 w-1/6 max-sm:w-1/2 max-sm:h-[15vh] h-[20vh] p-2 max-sm:p-1 relative">
                            <div className="border rounded-lg shadow-sm hover:shadow-md transition-shadow duration-200 h-full group">
                              <div className="aspect-w-3 aspect-h-4 relative h-full">
                                {(() => {
                                  const url = doc?.url || "";
                                  const isMp4 = url.toLowerCase().endsWith('.mp4');
                                  if (isMp4) {
                                    return (
                                      <video
                                        width="100%"
                                        // height="100%"
                                        style={{ height: 'inherit', objectFit: 'cover', borderRadius: '0.5rem', background: '#000' }}
                                        controls={false}
                                        muted
                                        preload="metadata"
                                        poster=""
                                      >
                                        <source src={url + '#t=0.5'} type="video/mp4" />
                                        Your browser does not support the video tag.
                                      </video>
                                    );
                                  } else {
                                    return (
                                      <img 
                                        src={PDFThumbnail}
                                        alt={doc?.title || 'Document'}
                                        className="object-cover w-full h-full rounded-t-lg" 
                                        onError={(e) => {
                                          e.target.onerror = null;
                                          e.target.src = '/default-doc.png';
                                        }}
                                      />
                                    );
                                  }
                                })()}
                                {/* Transparent overlay with preview button */}
                                <div className="absolute inset-0 bg-black bg-opacity-50 opacity-0 group-hover:opacity-100 transition-opacity duration-200 flex items-center justify-center">
                                  <button
                                    onClick={() => handleShowPreviewer(doc)}
                                    className="bg-white text-gray-800 px-4 py-2 rounded-md hover:bg-gray-100 transition-colors duration-200 flex items-center gap-2"
                                  >
                                    <Icon.Eye size={16} />
                                    Preview
                                  </button>
                                </div>
                              </div>
                            </div>
                            <div className="mt-2 max-sm:mt-1">
                              <h3 title={doc?.title} className="text-sm max-sm:text-xs font-medium text-gray-900 truncate">
                                {doc?.title || 'Untitled Document'}
                              </h3>
                            </div>
                          </div>
                        );
                      })
                      }</div>
                    {/* New Learn More flow  */}
                    {/* <div className="text-white text-[20px] mt-6 max-sm:mt-2 max-sm:mb-4 col-span-3 max-sm:col-span-11">
                          <div
                            className={`flex flex-col ${(chat_listing.length === index+1 && transitionFlag === true) ? "swing-in-right-bck":""}`}
                          >
                            <div
                              className="flex gap-3 pb-2 border-b border-gray-400"
                            >
                              <Stack
                                className="my-auto text-[var(--brand-primary)] text-[15px]"
                              />

                              <div
                                className="font-[600] text-[var(--brand-primary)] text-[18px] leading-[17px] "
                              >
                                Resources
                              </div>
                            </div>
                              <div className="flex">
                                <div className="text-[#59B3C6] py-3 px-2 w-full max-sm:px-0">
                                  {item.meta_data?.crawled_urls?.count > 0 && <>
                                      <div
                                        onClick={(e) =>
                                          handleLinks(item, "crawled_urls")
                                        }
                                        className="border border-[var(--brand-primary)] max-sm:w-full shadow-md leading-[17px] mr-[0.5rem] max-sm:mr-0 px-2 py-1 rounded-md mb-2"
                                      >
                                        <div className="mt-2">
                                          <div className="mr-1 mb-2 flex justify-between">
                                            <img
                                              className="w-6 h-6"
                                              src={item.meta_data?.crawled_urls?.list[0]?.favicon}
                                              alt="favicon"
                                            />
                                            <span className="inline-flex cursor-pointer gap-2 items-center rounded-md bg-white px-2 py-1 text-xs font-medium text-[var(--brand-primary)] ring-1 ring-inset ring-[var(--brand-primary)]">
                                              Crawled Url
                                            </span>
                                          </div>
                                        </div>
                                        <div className="pr-8 relative">
                                          <div
                                            className={`font-[600] text-[12px] ${item.meta_data?.crawled_urls?.list[0]?.description ? "mb-0":"mb-3"}`}
                                            title={item.meta_data?.crawled_urls?.list[0]?.title}
                                          >{
                                              item.meta_data?.crawled_urls?.list[0]?.title
                                                ?.length > 35
                                                ? `${item.meta_data?.crawled_urls?.list[0]?.title.slice(
                                                    0,
                                                    30
                                                  )}..`
                                                : `${item.meta_data?.crawled_urls?.list[0]?.title},`
                                            }
                                          </div>
                                          <div className="text-[10px] text-gray-600">
                                            {item.meta_data?.crawled_urls?.list[0]?.description
                                              ?.length > 80
                                              ? `${item.meta_data?.crawled_urls?.list[0]?.description?.slice(
                                                  0,
                                                  80
                                                )}...`
                                              : item.meta_data?.crawled_urls?.list[0]?.description}
                                          </div>
                                          <div className="absolute flex justify-center items-center bg-[var(--brand-primary)] text-[white] right-1 top-0 text-xs h-6 w-6 border border-[var(--brand-primary)] rounded-full p-0">
                                            {item.meta_data?.crawled_urls?.count}
                                          </div>
                                        </div>
                                      </div>
                                  </>}
                            
                                  {item.meta_data?.docs?.count > 0 && <>
                                      <div
                                        onClick={(e) =>
                                          handleLinks(item, "documents")
                                        }
                                        className="border border-[var(--brand-primary)] max-sm:w-full shadow-md leading-[17px] mr-[0.5rem] max-sm:mr-0 px-2 py-1 rounded-md mb-2"
                                      >
                                        <div className="mt-2">
                                          <div className="mr-1 mb-2 flex justify-between">
                                            <img
                                              className="w-6 h-6"
                                              src={PdfImage}
                                              alt="favicon"
                                            />
                                            <span className="inline-flex cursor-pointer gap-2 items-center rounded-md bg-white px-2 py-1 text-xs font-medium text-[var(--brand-primary)] ring-1 ring-inset ring-[var(--brand-primary)]">
                                              Documents
                                            </span>
                                          </div>
                                        </div>
                                        <div className="pr-8 relative">
                                          <div
                                            className={`font-[600] text-[12px] ${item.meta_data?.crawled_urls?.list[0]?.description ? "mb-0":"mb-3"}`}
                                            title={item.meta_data?.docs?.list[0]?.title}
                                          >{
                                              item.meta_data?.docs?.list[0]?.title
                                                ?.length > 35
                                                ? `${item.meta_data?.docs?.list[0]?.title.slice(
                                                    0,
                                                    30
                                                  )}..`
                                                : `${item.meta_data?.docs?.list[0]?.title},`
                                            }
                                          </div>
                                          <div className="text-[10px] text-gray-600">
                                            {
                                              item.meta_data?.docs?.list[0]?.description
                                                ?.length > 80
                                                ? `${item.meta_data?.docs?.list[0]?.description.slice(
                                                    0,
                                                    80
                                                  )}..`
                                                : `${item.meta_data?.docs?.list[0]?.description},`
                                            }
                                          </div>
                                          <div className="absolute flex justify-center items-center bg-[var(--brand-primary)] text-[white] right-1 top-0 text-xs h-6 w-6 border border-[var(--brand-primary)] rounded-full p-0">
                                            {item.meta_data?.docs?.count}
                                          </div>
                                        </div>
                                      </div>
                                  </>}
                                </div>
                              </div>
                          </div>
                    </div> */}
                    {/* Learn More flow */}
                  </div>
                  {/* New struc messages + suggestion + Learn more*/}

                </div>
              );
            })
          ) : (
            <></>
          )}
          {/* Dummy Question */}
          {newPrompt && Object.keys(newPrompt).length > 0 && newPrompt.is_writing === true && (
            <>
              <div className="min-h-[65vh]">
                <div className="flex zapUser">
                  <div
                    className={`py-[20px] max-sm:py-3 w-full sm:w-[70%] max-sm:w-full text-left max-sm:mr-0 mr-[0.5rem] relative content-[''] rounded-tl-[20px] rounded-br-[20px] rounded-bl-[20px]`}
                  >
                    <div
                      className={`text-gray-900 capitalize max-sm:leading-7 leading-[42px] max-sm:text-[18px] text-[20px] font-[600] max-sm:mb-0 mb-2 fontClass`}
                    >
                      {newPrompt.prompt}
                    </div>
                  </div>
                </div>
                {(message?.is_writing !== true && (message?.answer === "") && isLoadings === true) ? 
                  (
                  <div className="zapBot">
                    <div
                      className={`pb-[20px] w-full mb-[1.25rem] text-left botMessageAMA`}
                    >
                      <div
                        className={`text-[#000000] flex loading font-[500] text-[14px]`}
                      >
                        <div className="flex items-center gap-2">
                          <div className="flex space-x-1">
                            <div className="w-2 h-2 bg-[var(--brand-primary)] rounded-full animate-bounce"></div>
                            <div className="w-2 h-2 bg-[var(--brand-primary)] rounded-full animate-bounce" style={{animationDelay: '0.1s'}}></div>
                            <div className="w-2 h-2 bg-[var(--brand-primary)] rounded-full animate-bounce" style={{animationDelay: '0.2s'}}></div>
                          </div>
                          <span className="typing-animation">{thinkingMessages[thinkingMessage]}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  )
                  :
                  (<div className="grid grid-cols-10 gap-x-8 max-sm:gap-x-2">
                      <div className="flex flex-col sm:col-span-9 max-sm:col-span-10">
                        {/* Zap bot reply Message */}
                        <div className="zapBot">
                          <div
                            className={`pb-[20px] max-sm:pb-3 w-[100%] sm:w-[100%] text-left botMessageAMA`}
                          >
                            <div
                              className={`text-gray-600 leading-[22px] max-sm:leading-[20px] font-[500] text-[14px] max-sm:text-[13px] mb-2 fixWrap`}
                            >
                              <div className="markdown-content" dangerouslySetInnerHTML={{ __html: renderMarkdown(message?.answer) }} />
                            </div>
                          </div>
                      </div>
                    </div>
                  </div>)
                }
              </div>  
            </>
          )}
          {/* Dummy Question */}
        </div>
        {/* Send Bar */}

        <div className="w-full flex mb-4 max-sm:mb-2 mt-3">
          <div className="w-[65%] max-sm:w-full ">
            {/* Audio Controls */}
            <div className="flex items-center justify-between mx-7 max-sm:mx-2 mb-2">
              {/* Language detection display */}
              {detectedLanguage && (
                <div className="text-xs max-sm:text-[10px] text-blue-600 bg-blue-100 px-2 py-1 max-sm:px-1.5 max-sm:py-0.5 rounded">
                  🌐 {detectedLanguage}
                </div>
              )}
              
              {/* Audio Controls */}
              <div className="flex items-center gap-3 max-sm:gap-2">
                
                {/* Audio Mute Button */}
                <button
                  onClick={toggleAudioMute}
                  className={`flex items-center gap-2 max-sm:gap-1 px-3 max-sm:px-2 py-1.5 max-sm:py-1 rounded-full transition-all duration-200 ${
                    isAudioMuted 
                      ? 'bg-red-100 hover:bg-red-200 text-red-700' 
                      : 'bg-green-100 hover:bg-green-200 text-green-700'
                  }`}
                  title={isAudioMuted ? "Unmute Audio" : "Mute Audio"}
                >
                  {isAudioMuted ? (
                    <>
                      <Icon.VolumeOffFill size={16} />
                      <span className="text-xs max-sm:text-[10px] font-medium">Muted</span>
                    </>
                  ) : (
                    <>
                      <Icon.VolumeUpFill size={16}/>
                      <span className="text-xs max-sm:text-[10px] font-medium">Audio</span>
                    </>
                  )}
                </button>
                
                {/* Audio Playing Indicator */}
                {isAudioPlaying && !isAudioMuted && (
                  <div className="flex items-center gap-1 max-sm:gap-0.5">
                    <div className="flex space-x-1 max-sm:space-x-0.5">
                      <div className="w-1 h-3 max-sm:h-2 bg-blue-500 rounded-full animate-pulse"></div>
                      <div className="w-1 h-4 max-sm:h-3 bg-blue-500 rounded-full animate-pulse" style={{animationDelay: '0.1s'}}></div>
                      <div className="w-1 h-2 max-sm:h-1 bg-blue-500 rounded-full animate-pulse" style={{animationDelay: '0.2s'}}></div>
                    </div>
                    <span className="text-xs max-sm:text-[10px] text-blue-600 ml-1 max-sm:ml-0.5">Playing</span>
                  </div>
                )}
              </div>
            </div>
            <div className="bg-white relative flex flex-col border border-gray-300 rounded-lg w-full  p-4 max-sm:p-3 mx-7 max-sm:mx-2" style={{ minHeight: '36px' }}>
              <textarea
                ref={inputRef}
                className="block w-full pl-4 max-sm:pl-3 listing pr-12 max-sm:pr-10 pt-4 max-sm:pt-3 pb-10 max-sm:pb-8 border-none rounded-lg focus:outline-none text-gray-700 bg-transparent text-base max-sm:text-sm placeholder-gray-400 resize-none overflow-y-auto hide-scrollbar inputBorder max-sm:w-full"
                placeholder="Ask me anything....."
                rows={1}
                style={{ minHeight: '76px', maxHeight: '120px' }}
                value={question}
                disabled={isLoadings === true}
                onChange={(e) => {
                  setQuestion(e.target.value);
                  if (e?.target?.value?.includes('/d')) {
                    const searchTextIndex = e?.target?.value?.lastIndexOf('/d');
                    setSearchCanned(e?.target?.value?.substring(searchTextIndex + 2));
                  } else {
                    setShowOverlay(false);
                    setSearchCanned('');
                  }
                }}
                onKeyDown={(e) => {
                  if (e.key === "Enter" && !e.shiftKey && question !== "" && isLoadings !== true && searchCanned?.length === 0) {
                    e.preventDefault();
                    handleSubmit(question);
                  } else if (e.key === "Enter" && !e.shiftKey && question !== "" && searchCanned?.length > 0) {
                    e.preventDefault();
                    dispatch({
                      type: FETCH_CANNED_DOCS,
                      payload: null,
                    });
                    setShowOverlay(true);
                    dispatch(fetchCannedListing(authToken, searchCanned));
                  }
                }}
              />
              <div className="bg-white rounded-b-lg w-full left-0 bottom-0 flex justify-between px-2 absolute">
                <button
                  onClick={toggleRecording}
                  disabled={isLoadings === true}
                  className={`rounded-full p-2 max-sm:p-1.5 transition-colors `}
                  aria-label={
                    microphonePermission === 'denied' 
                      ? "Microphone access denied" 
                      : isRecording 
                      ? "Stop Recording" 
                      : "Start Recording"
                  }
                  title={
                    microphonePermission === 'denied' 
                      ? "Please allow microphone access in your browser settings" 
                      : microphonePermission === 'prompt'
                      ? "Click to request microphone access"
                      : isRecording 
                      ? "Stop Recording" 
                      : "Start Recording"
                  }
                >
                  {microphonePermission === 'denied' ? (
                    <Icon.MicMuteFill 
                      size={20} 
                      className="text-gray-400" 
                    />
                  ) : (
                    <Icon.MicFill 
                      size={20} 
                      className={isRecording ? "text-red-500" : "text-gray-600"} 
                    />
                  )}
                </button>
                <button
                disabled={isLoadings === true}
                onClick={() => {
                  if (isLoadings !== true && searchCanned?.length === 0) {
                    handleSubmit(question);
                  } else if (searchCanned?.length > 0) {
                    dispatch({
                      type: FETCH_CANNED_DOCS,
                      payload: null,
                    });
                    setShowOverlay(true);
                    dispatch(fetchCannedListing(authToken, searchCanned));
                  }
                }}
                className="bg-white rounded-full p-2 max-sm:p-1.5 transition-colors"
                aria-label="Send"
              >   
                <Icon.ArrowRightCircleFill size={28} className="text-black" />
                </button>
              </div>
            </div>
          </div>
        </div>
        {/* Send Bar */}
        {/* View Mode    */}
      <Transition.Root show={showPreviewer} as={Fragment}>
          <Dialog as="div" className="relative z-10"  onClose={handleHidePreviewer}>
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
            </Transition.Child>

            <div className="fixed inset-0 z-10 overflow-y-auto">
              <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
                <Transition.Child
                  as={Fragment}
                  enter="ease-out duration-300"
                  enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                  enterTo="opacity-100 translate-y-0 sm:scale-100"
                  leave="ease-in duration-200"
                  leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                  leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                >
                  <Dialog.Panel className="relative transform overflow-hidden rounded-lg bg-[#f2f2f2] px-4 pb-4 pt-4 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-2xl max-sm:max-w-full max-sm:mx-2 sm:py-4 sm:px-4">
                    <div className={previewData.type !== "txt" ? "bg-[#f2f2f2]":"not-italic font-semibold bg-white rounded-[15px]"}>
                      {previewData ? (
                        (() => {
                          const url = previewData?.url || "";
                          const isMp4 = url.toLowerCase().endsWith('.mp4');
                          if (isMp4) {
                            return (
                              <video width="100%" height="550px" controls>
                                <source src={url} type="video/mp4" />
                                Your browser does not support the video tag.
                              </video>
                            );
                          } else {
                            return (
                              <embed src={url} type="application/pdf" width="100%" height="550px" />
                            );
                          }
                        })()
                      ) : (
                        <p>No document to preview</p>
                      )}
                    </div>
                  </Dialog.Panel>
                </Transition.Child>
              </div>
            </div>
          </Dialog>
      </Transition.Root>
      <Transition.Root show={showMeeting} as={Fragment}>
      <Dialog className="relative z-10" onClose={setShowMeeting}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
        </Transition.Child>

        <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
          <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
              <Dialog.Panel className="relative transform overflow-hidden rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-sm max-sm:max-w-full max-sm:mx-2 sm:p-1">
              <>
                  {
                    <div className="zapBot slide-in-left">
                      <div
                        className={`${
                          "bg-[#FFFFFF]"
                        } p-[20px] max-sm:p-4 relative w-full sm:w-[100%] mb-[1.25rem] text-left botMessage`}
                      >
                        <div
                          // style={{ color: primaryColor }}
                          className="font-[600] mt-2 mb-4 text-black text-[16px] max-sm:text-[14px] mx-auto text-center"
                        >
                          Schedule a Meeting
                        </div>
                        <IoClose onClick={()=>{setShowMeeting(false)}} className="absolute top-5 right-5 max-sm:top-3 max-sm:right-3 text-lg max-sm:text-base cursor-pointer"></IoClose>

                        <div
                          className={`${"text-[#000000]"
                          }  leading-[22px] font-[500] text-[14px] mb-2 fixWrap`}
                        >
                          {calendarCounter === 0 && (
                                                          <div className="px-4 pb-6 pt-1 max-sm:px-2">
                              { <Calendar
                              // onChange={setSelectedDate}
                              // value={selectedDate}
                              className="mx-auto pb-6 rounded-md px-2 max-sm:px-1"
                              minDate={new Date()}
                              // maxDate={maxDate}
                              // tileDisabled={tileDisabled}
                              prev2Label={null}
                              next2Label={null}
                            />}

                              
                              </div>
                          )}
                          {calendarCounter === 1 && (
                            <div >
                              {(<div className="px-4 pb-6 pt-1 max-sm:px-2 grid grid-cols-4 max-sm:grid-cols-2 gap-2 max-sm:gap-1 h-[40vh] max-sm:h-[35vh] overflow-auto timeSelector">
                                {
                                timeSlots?.map((item, cb_index) => {
                                  return (
                                    <div
                                      onClick={() => {
                                        handleTimeSelection(item);
                                      }}
                                      className={`${
                                        timeSelected === item
                                          ? "outline-[2.5px]"
                                          : "outline-[1px]"
                                      } cursor-pointer my-auto text-black col-span-2 max-sm:col-span-1 py-2 max-sm:py-1.5 px-4 max-sm:px-2 outline outline-[#0060E6] hover:outline-[2.5px] font-[600] max-sm:font-medium rounded-md text-center max-sm:text-xs`}
                                    >
                                      {item}
                                    </div>
                                  );
                                })
                                }
                              </div>
                              )}
                            </div>
                          )}
                          {calendarCounter === 2 && (
                                                        <div className="flex flex-col my-6 mx-4 max-sm:mx-2 meetCalendar">
                              <input
                                required
                                type="text"
                                id="first_name"
                                // onChange={(e) => {
                                //   setMeetingName(e.target.value);
                                // }}
                                className="meetingInput max-sm:text-sm"
                                placeholder="Name"
                              />
                              <input
                                required
                                type="text"
                                id="first_name"
                                // value={meetingEmail}
                                // onChange={(e) => {
                                //   if(leadEmail === ""){
                                //     setMeetingEmail(e.target.value)
                                //   }                
                                // }}
                                className="meetingInput mt-2 max-sm:text-sm"
                                placeholder="Email"
                              />
                              <textarea
                                // onChange={(e) => {
                                //   setMeetingReason(e.target.value);
                                // }}
                                id="message"
                                rows="2"
                                class="meetingInput resize-none mt-2 max-sm:text-sm"
                                placeholder="Reason for Meeting"
                              ></textarea>
                              {/* <div className="p-1 text-red-700 text-[12px] my-auto"> */}
                              {/* {meetingError  &&  meetingError == "Email" && "Please enter a valid business email."}  */}
                              {/* {meetingError  && meetingError == "Complete" && "* Please fill all the fields."} */}
                              {/* </div> */}
                            </div>
                          )}
                          {calendarCounter === 3 && (
                            <div className="flex flex-col my-6 mx-4 ">
                              <img
                                src="https://s3-zap.s3.ap-south-1.amazonaws.com/Animation%20-%201704261503951%20%281%29-1713161331.gif"
                                className="w-[20%] mx-auto mt-8"
                                alt="loader-gif"
                              />
                              <div className="p-1 text-[#309A00] text-[20px] my-8 mx-auto">
                                Meeting Scheduled
                              </div>
                            </div>
                          )}
                          {calendarCounter !== 3 && (
                              <div className="flex justify-between px-5 max-sm:px-3 pt-4">
                                {
                                  <div
                                    className="text-[#0060E6] text-end  cursor-pointer font-[700] max-sm:font-[600]"
                                    onClick={handleCalendarBack}
                                  >
                                    {calendarCounter > 0 ? "Back" : ""}
                                  </div>
                                }
                                <div
                                  className="text-[#0060E6] text-end  cursor-pointer font-[700] max-sm:font-[600]"
                                  onClick={handleCalendarNext}
                                >
                                  {calendarCounter > 1 ? "Submit" : "Next"}
                                </div>
                              </div>
                            )}
                        </div>
                      </div>
                    </div>
                  }
                </>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
      <Transition.Root show={showAgent} as={Fragment}>
      <Dialog className="relative z-10" onClose={()=>{setShowAgent(false);setShowAgentCounter(0);}}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
        </Transition.Child>

        <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
          <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
              <Dialog.Panel className="relative transform overflow-hidden rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-sm max-sm:max-w-full max-sm:mx-2 sm:p-1">
              <div>
                  <div className="mt-3 text-center sm:mt-5">
                    {/* <Dialog.Title as="h3" className="text-base font-semibold leading-6 text-gray-900">
                      Payment successful
                    </Dialog.Title> */}
                    <div className="mt-2 mb-4">
                      <p className="text-sm max-sm:text-xs text-gray-500">
                        {showAgentCounter === 0 ? "Would you like to connect to a support agent?":"Searching for an available agent......."}
                      </p>
                    </div>
                  </div>
                </div>
                {showAgentCounter === 0 && <div className="mb-5 mx-auto sm:mt-6 sm:grid sm:grid-flow-row-dense">
                  <button
                    type="button"
                    className="inline-flex w-[60%] max-sm:w-[80%] justify-center mx-auto rounded-md bg-[#49BCD2] px-3 py-2 max-sm:px-2 max-sm:py-1.5 text-sm max-sm:text-xs font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600 sm:col-start-2"
                    onClick={() => setShowAgentCounter(1)}
                  >
                    Yes
                  </button>
                  <button
                    type="button"
                    className="mt-3 max-sm:mt-2 inline-flex w-[60%] max-sm:w-[80%] justify-center mx-auto rounded-md bg-white px-3 py-2 max-sm:px-2 max-sm:py-1.5 text-sm max-sm:text-xs font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:col-start-1 sm:mt-0"
                    onClick={() =>{ setShowAgent(false);setShowAgentCounter(0);}}
                  >
                    No
                  </button>
                </div>}
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
      {/* Global disclaimer at bottom - user can scroll down to see it */}
      {showDisclaimer && (
        <div className="w-full px-6 max-sm:px-4 pb-6 mt-4">
          <div className="bg-gray-50 border border-gray-200 rounded-lg p-4 max-sm:p-3 text-xs max-sm:text-[11px] text-gray-600 leading-relaxed">
            <p className="font-semibold text-gray-700 mb-2">Disclaimer:</p>
            {apiDisclaimer ? (
              <p className="whitespace-pre-line">{apiDisclaimer}</p>
            ) : (
              <>
                <p className="mb-3">
                  The chatbot provides educational information regarding Canara Robeco Banking and Financial Services Fund launched on 27th February 2026. This response has been synthetically generated using AI-based tool from original source documents uploaded by organization. While reasonable efforts have been made to ensure accuracy, the output is system-generated and may require independent verification. It should not be construed as legal, regulatory, financial or investment advice and users are advised to review and validate the information before relying on it.
                </p>
                <p>
                  The use of this application is exclusively limited to the employees of Canara Robeco Asset Management Company Limited for testing and should not be used for any other purpose. Unauthorised use of the application is strictly prohibited.
                </p>
              </>
            )}
          </div>
        </div>
      )}
      </div>
    </>
  );
};

export default InnerChat;